// extracted by mini-css-extract-plugin
export default {"appItem":"CkbXvz","description":"qU5ZUd"};